import { useQuery } from '@tanstack/react-query';
import { getInstitutionScholarships } from '@api/scholarships';

export const useInstitutionScholarships = (institutionId: number, enabled: boolean) =>
  useQuery({
    queryKey: ['institutionScholarships', institutionId],
    queryFn: () => getInstitutionScholarships(institutionId),
    enabled,
    refetchOnWindowFocus: false,
  });
